<template lang="html">
  <nav class="space-x-4 flex flex-col items-end lg:items-start lg:flex-row leading-tight pt-1 text-base md:text-lg lg:pr-4">
    <router-link
      v-for="link in site.menu"
      :key="link.uid"
      :to="{ name: link.uid }"
      >{{ link.title }}</router-link
    >
  </nav>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState(["site"]),
};
</script>
